import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import type { TTransportCostPerKmRes } from 'api/swagger';
import { useTransformToTableData } from 'shared/hooks/use-transform-to-table-data';
import { CostEditableCell } from 'components/costs/costs-per-km-list/comonents/cost-editable-cell';
import type { ICostsPerKmListProps } from './types';
import { getLastMonths } from './utils';

export const CostsPerKmList: React.FC<ICostsPerKmListProps> = (props) => {
  const { transportKmCostData, isEditing, addDirty, removeDirty } = props;

  const tableData = useTransformToTableData(transportKmCostData);

  const months = getLastMonths();

  const columns: ColumnsType<TTransportCostPerKmRes> = [
    {
      title: 'Plate number',
      dataIndex: 'plateNumber',
    },
    ...months.map((month) => ({
      title: month.format('MMM YYYY'),
      key: month.format('YYYY-MM'),
      render: (_: unknown, record: TTransportCostPerKmRes) => {
        const costItem = record.costs.find((cost) => dayjs(cost.date).isSame(month, 'month'));

        if (isEditing && costItem) {
          return (
            <CostEditableCell
              costPerKmId={costItem.id}
              initialCost={costItem.cost}
              addDirty={addDirty}
              removeDirty={removeDirty}
            />
          );
        }

        return costItem ? costItem.cost : '-';
      },
    })),
  ];

  return <Table size='small' columns={columns} dataSource={tableData} pagination={false} bordered />;
};
